<template>
<div>
	<!-- <van-nav-bar
			title="积分规则"
			style="background:linear-gradient(to right,#19CBDA,#2EDD9C);color:#fff;position: fixed;top:0;width:100%"
		>
		<template #left>
			<van-icon @click="onClickLeft" name="arrow-left" color="#fff" size="18" />
		</template>
	</van-nav-bar> -->
	<div class="content">
		<div class="text-area">
			<h2 class="title">{{contents.title}}</h2>
			<ul class="ul">
				<li class="item" v-for="(item,j) in contents.Integration1" :key="j+'a'">
					{{item}}
				</li>
				<li class="item itemTip" v-for="(item,j) in contents.reply" :key="j+'b'">
					{{item}}
				</li>
				<li class="item" v-for="(item,j) in contents.Integration2" :key="j+'c'">
					{{item}}
				</li>
				<li class="item itemTip" v-for="(item,j) in contents.reply1" :key="j+'p'">
					{{item}}
				</li>
				<li class="item" v-html="item" v-for="(item,j) in contents.Integration3" :key="j+'q'">
					{{item}}
				</li>
			</ul>
			<!-- <h2 class="title">{{useIntegration1.title}}</h2> -->
			<!-- <ul class="ul">
				<li class="item" v-for="(item,j) in useIntegration1.items" :key="j+'d'">
					{{item}}
				</li>
			</ul> -->
		</div>
		<!-- <div class="text-area"> -->
			<!-- <van-row style="margin-bottom:10px">
				<van-col span="8" :style="titStyle">会员等级</van-col>
				<van-col span="8" :style="titStyle">称号</van-col>
				<van-col span="8" :style="titStyle">权限</van-col>
			</van-row> -->
			<!-- <van-row v-for="(item,i) in upgrade" :key="i+'e'" style="margin-bottom:10px">
				<van-col span="8" :style="cssType">{{item.one}}</van-col>
				<van-col span="8" :style="cssType">{{item.two}}</van-col>
				<van-col span="8" :style="cssType">{{item.three}}</van-col>
			</van-row> -->
		<!-- </div> -->
		<div class="text-area">
			<h2 class="title">{{acquisition.tit}}</h2>
			<ul class="ul">
				<li class="item" v-for="(item,j) in acquisition.text" :key="j+'g'">
					{{item}}
				</li>
				<!-- <li class="item" v-html="item" v-for="(item,j) in acquisition.todo" :key="j+'z'">
					{{item}}
				</li> -->
			</ul>
		</div>
		<div class="text-area">
			<h2 class="title">{{acquisition.tit2}}</h2>
			<ul class="ul">
				<li class="item itemTip" v-for="(item,j) in acquisition.text1" :key="j+'f'">
					{{item}}
				</li>
			</ul>
		</div>
		<!-- <div class="text-area">
			<van-row style="margin-bottom:10px">
				<van-col span="8" :style="titStyle">群组升级</van-col>
				<van-col span="8" :style="titStyle">称号</van-col>
				<van-col span="8" :style="titStyle">权限</van-col>
			</van-row> -->
			<!-- <van-row v-for="(item,i) in groupUpgrade" :key="i+'o'" style="margin-bottom:10px">
				<van-col span="8" :style="cssType">{{item.one}}</van-col>
				<van-col span="8" :style="cssType">{{item.two}}</van-col>
				<van-col span="8" :style="cssType">{{item.three}}</van-col>
			</van-row> -->
		<!-- </div> -->
		<p class="tips">如有其它疑问请致电售后服务电话</p>
		<p class="telphone">400-618-0099</p>
	</div>
</div>
	
</template>

<script>
import Vue from 'vue';
import { Col, Row } from 'vant';

Vue.use(Col);
Vue.use(Row);
	export default {
		data() {
			return {
				cssType:{
					textAlign: 'center',
					color:'#999'
				},
				titStyle:{
					textAlign: 'center',
					fontWeight:'bold',
					color:'#23d3bd'
				},
				title: 'Hello',
				contents: {
						title: '积分:',
						Integration1: [
							'1、评论;',
							'2、点赞;',
							'3、转发一次可获取1积分（一天5积分封顶）。',
							'4、发表动态一次获得2积分（一天6积分封顶）。',
							'5、组群签到获得1积分（一天10积分封顶）',
							'6、动态被评论；',
							'7、动态被点赞；',
							'8、动态被转发',
							// '6、发表的动态被他人回复（点赞、评论、转发）',
							// '7、组群签到；一次获得1积分（一天10积分封顶）',
							
							
						],
					//	8、动态被转发；
						reply:[
							'有效回复1-10获得1积分。',
							'有效回复11-20获得3积分。',
							'有效回复21-30获得6积分。',
							'有效回复31-50，获得10积分。',
							'有效回复50以上，获得15积分。（一天35积分封顶）'
						],
						Integration2:[
							'9、参加活动，获得5积分。（一天10积分封顶）',
							'10、观看课程学习5分钟获得1积分，十分钟获得3积分，三十分钟获得10积分。六十分钟获得25积分。一百二十分钟获得50积分。',
							'11、用户升级可以获得积分奖励'
						],
						reply1:[
							'一级获得 0积分；',
							'二级获得 50积分；',
							'三级获得 150积分；',
							'四级获得 300积分；',
							'五级获得 500积分；',
							'六级获得 800积分；',
							'七级获得 1200积分；',
							'八级获得 2000积分；'
						],
						Integration3:[
							'12、设备训练; 一次可获取1积分（一天100积分封顶）',
							'13、多人竞技；一次可获取5积分（一天15积分封顶）',
							// '<strong>TODO:奖励规则条件暂定</strong>',
							// '14、排行榜',
							// '15、积分兑换商品',
							// '16、积分兑换课程返还',
							// '17、购买商品',
							// '18、购买课程',
							// '19、挑战',
							// '20、赛事；'
							
						]
					},
					// useIntegration1:{
					// 	title: '会员积分的使用：',
					// 	items: [
					// 		'1、购买付费课程、商品可用积分抵扣现金。抵扣比例为100积分等于1人民币。',
					// 		'2、直接兑换积分商品。',
					// 		'3、发布比赛、挑战时可以使用积分作为活动奖励使用。',
					// 		'4、部分挑战、比赛、活动需支付积分方可报名参加。'
					// 	]
					// },
					// upgrade:[
					// 	{
					// 		one:'一级',
					// 		two:'健康小白',
					// 		three:''
					// 	},
					// 	{
					// 			one:'二级（累计积分100）',
					// 			two:'健身爱好者',
					// 			three:''
					// 	},
					// 	{
					// 			one:'三级（累计积分500）',
					// 			two:'健身达人',
					// 			three:''
					// 	},
					// 	{
					// 			one:'四级（累计积分1000）',
					// 			two:'健身教练',
					// 			three:''
					// 	},
					// 	{
					// 			one:'五级（累计积分2000）',
					// 			two:'健美先生',
					// 			three:''
					// 	},
					// 	{
					// 			one:'六级（累计积分4000）',
					// 			two:'健美教练',
					// 			three:''
					// 	},
					// 	{
					// 			one:'七级（累计积分6500）',
					// 			two:'健美冠军',
					// 			three:''
					// 	},
					// 	{
					// 			one:'八级（累计积分10000）',
					// 			two:'健美王者',
					// 			three:''
					// 	}
					// ],
					// groupUpgrade:[
					// 	{
					// 		one:'一级（升级需50经验）',
					// 		two:'',
					// 		three:''
					// 	},
					// 	{
					// 			one:'二级（升级需200经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'三级（升级需500经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'四级（升级需1500经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'五级（升级需3000经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'六级（升级需6000经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'七级（升级需15000经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'八级（升级需20000经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'九级（升级需40000经验）',
					// 			two:'',
					// 			three:''
					// 	},
					// 	{
					// 			one:'十级（升级需100000经验）',
					// 			two:'',
					// 			three:''
					// 	}
					// ],
					acquisition:{
						tit:'经验：',
						tit2:'等级:',
						text:[
							'1、评论；2、点赞，3、转发；一次获取1经验（一天3经验封顶）',
							'4、发表动态；一次获取2经验（一天4经验封顶）',
							'5、组群签到；一次获取2经验（一天6经验封顶）',
							'6、动态被评论；7、动态被点赞；8、动态被转发；一次获取3经验（一天3经验封顶）',
							'9、参加活动；一次获取4经验（一天8经验封顶）',
							'10、观看课程学习；一次获取3经验（一天6经验封顶）',
							'11、用户升级；',
							'12、设备训练; 一次可获取1积分（一天15经验封顶）',
							'13、多人竞技；一次可获取3积分（一天9经验封顶）'
						],
						// todo:[
						// 	'<strong>TODO:奖励规则条件暂定</strong>',
						// 	'14、排行榜；',
						// 	'15、积分兑换商品；',
						// 	'16、积分兑换课程返还；',
						// 	'17、购买商品；',
						// 	'18、购买课程；',
						// 	'19、挑战；',
						// 	'20、赛事；'
						// ],
						text1:[
							'一级 0-50；',
							'二级 50-200；',
							'三级 200-400；',
							'四级 400-600；',
							'五级 600-1000；',
							'六级 1000-1500；',
							'七级 1500-2500；',
							'八级 2500-1000000；'
						]

					}
						
			}
		},
		methods: {
		}
	}
</script>

<style>
	ul,li{
		list-style: none;
	}
	.content {
		margin-top:10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		font-size: 14px;
		color: #4F5371;
	
	}

	.logo {
		width: 480px;
		height: 320px;	
	}

	.text-area {
		display: flex;
		background: #fff;
		flex-direction: column;
		justify-content: center;
		margin-bottom:10px;
		border-radius: 10px;
		padding:10px;
		width: 95%;
	}

	.title {
		font-size: 14px;
		color: #23d3bd;
	}

	.ul {
		padding: 0 10px 10px 10px;
		margin: 0;
		
		/* border-bottom: 1px solid #333; */
	}

	.item {
		color: #979797;
		padding-left: 0;
		margin-left: 0;
	}
.itemTip{
	margin-left:25px
}

	.special {
		color: #FEDA2E;
	}

	.tips {
		color: #979797;
	}

	.telphone {		
		margin-top: 20px;
		color: #979797;
	}
</style>
